





































import { Component, Vue, Prop } from 'vue-property-decorator';
import ContestListItem from './ContestListItem.vue';
import AcceptPaymentModal from "./AcceptPaymentModal.vue"
import JoinContest from "./JoinContest.vue"
import PlaceholderContent from '@/shared/components/ui/PlaceholderContent.vue';

@Component({
    components: {
        ContestListItem,
        JoinContest,
        AcceptPaymentModal,
        PlaceholderContent
    },
    name: 'ContestList',
})
export default class ContestList extends Vue {
    @Prop() list!: any;
    @Prop() isHistory!: boolean;
    // @ts-ignore
    @Prop() loading!: boolean = false;
    @Prop() canLoadMore!: boolean;
    @Prop() openContestId !: any;
    private joinContestModal: boolean = false;
    private paymentModal: boolean = false;
    private joinContestId = 0;
    private joinContestName = "";
    private joinContestPrice = 0;


    private joinContest(name: string, id: number, price: any) {
        this.joinContestId = id;
        this.joinContestName = name;
        this.joinContestPrice = (price * 100);
        this.joinContestModal = true;
    }

    private closeModals() {
        this.joinContestModal = false;
        this.paymentModal = false;
    }

    private openPaymentModal() {
        this.paymentModal = true;
    }

    private showMore() {
        if (this.loading) {
            return
        }
        this.$emit('loadMoreContests')
    }

    mounted() {
        if (this.openContestId) {
            this.joinContest('test', this.openContestId, 0)
        }
    }

}
